import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import HeaderStats from "components/Headers/HeaderStats.js";

import Dashboard from "views/admin/Dashboard.js";
import Settings from "views/admin/Settings.js";
import StudentEvents from "components/Events/student/studentEvents";
import StudentFacility from "components/Facilites/student/studentFacilites";
import StudentInventory from "components/Inventory/student/studentInventory";
import StudentEventRegistration from "components/Events/student/StudentEventRegistration";
import StudentCreateFacilityReservation from "components/Facilites/student/FacilityRegistration";
import Labs from "components/Inventory/student/Labs";
import LabInventory from "components/Inventory/student/InventorybyLab";
import AssignCreateInventoryStudent from "components/Inventory/student/AssignInventory";
import ViewEventRegistration from "components/Events/student/ViewRegistration";
import ViewFacilityRegistration from "components/Facilites/student/ViewRegistration";
import ViewInvRegistration from "components/Inventory/student/ViewRegistration";
import AssignInventory from "components/Assign Inventory/AssignInventory";
import StudentProjects from "views/student/Project/StudentProjects";
const getToken = () => localStorage.getItem("token");

const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    const expired = decoded.exp * 1000 < Date.now();
    if (expired) {
      localStorage.clear();
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

const getRole = () => {
  const token = getToken();
  if (!token) return null;
  try {
    return jwtDecode(token).role;
  } catch {
    return null;
  }
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();
  const auth = isAuthenticated();
  const role = getRole();
  if (!auth) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-dark-primary min-h-screen">
        <AdminNavbar />
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          {children}
        </div>
      </div>
    </>
  );
};

const StudentRoutes = () => {
  return (
    <Routes>
      {/* <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        /> */}
      <Route
        path="/settings"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/events"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <StudentEvents />
          </ProtectedRoute>
        }
      />
      <Route
        path="/viewEventRegistration"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <ViewEventRegistration />
          </ProtectedRoute>
        }
      />
      <Route
        path="/viewFacilityRegistration"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <ViewFacilityRegistration />
          </ProtectedRoute>
        }
      />
      <Route
        path="/viewInvRegistration"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <ViewInvRegistration />
          </ProtectedRoute>
        }
      />
      <Route
        path="/student-event-registration"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <StudentEventRegistration />
          </ProtectedRoute>
        }
      />
      <Route
        path="/facilities"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <StudentFacility />
          </ProtectedRoute>
        }
      />

      <Route
        path="/facility-reservation"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <StudentCreateFacilityReservation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <Labs />
          </ProtectedRoute>
        }
      />

      <Route
        path="/inventory/labs/:id"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <LabInventory />
          </ProtectedRoute>
        }
      />

      <Route
        path="/assign-inventory"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <AssignInventory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory/registration"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <AssignCreateInventoryStudent />
          </ProtectedRoute>
        }
      />

      <Route
        path="/projects"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <StudentProjects />
          </ProtectedRoute>
        }
      />

      <Route path="/" element={<Navigate to="/student/dashboard" />} />
      <Route path="*" element={<Navigate to="/auth/login" />} />
    </Routes>
  );
};

export default StudentRoutes;
